<!--PENDIENTE POR MOFICAR-->
<template>
    <div class="table-responsive">
        <table class="table table-hover no-overflow">
            <thead>
                <tr>
                    <th @click="$emit('sort', 'promissoryNotes.referenceNumber')">
                        Folio pagaré
                        <span v-if="promissoryNoteStore.sortKey === 'promissoryNotes.referenceNumber'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'loanApplications.referenceNumber')">
                        Folio solicitud
                        <span v-if="promissoryNoteStore.sortKey === 'loanApplications.referenceNumber'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'prospects.referenceNumber')">
                        Folio prospecto
                        <span v-if="promissoryNoteStore.sortKey === 'prospects.referenceNumber'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'quotations.referenceNumber')">
                        Folio cotización
                        <span v-if="promissoryNoteStore.sortKey === 'quotations.referenceNumber'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'promissoryNotes.promissoryNumber')">
                        Número pagaré
                        <span v-if="promissoryNoteStore.sortKey === 'promissoryNotes.promissoryNumber'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'name')">
                        Nombre
                        <span v-if="promissoryNoteStore.sortKey === 'name'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'prospects.personTypes.name')">
                        Tipo de persona
                        <span v-if="promissoryNoteStore.sortKey === 'prospects.personTypes.name'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'promissoryNotes.createdAt')">
                        Fecha creación
                        <span v-if="promissoryNoteStore.sortKey === 'promissoryNotes.createdAt'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'promissoryNotes.updatedAt')">
                        Fecha actualización
                        <span v-if="promissoryNoteStore.sortKey === 'promissoryNotes.updatedAt'">
                            <i :class="promissoryNoteStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="promissoryNotes.length > 0">
                    <tr v-for="promissoryN in promissoryNotes" :key="promissoryN.promissoryNotes.id">
                        <td>{{ promissoryN.promissoryNotes?.referenceNumber }}</td>
                        <td>{{ promissoryN.loanApplications?.referenceNumber }}</td>
                        <td>{{ promissoryN.prospects?.referenceNumber }}</td>
                        <td>{{ promissoryN.quotations?.referenceNumber }}</td>
                        <td>{{ promissoryN.promissoryNotes?.promissoryNumber }}</td>
                        <td>{{ getName(promissoryN) }}</td>
                        <td>{{ promissoryN.prospects?.personTypes?.name }}</td>
                        <td>{{ $filters.formatDate(promissoryN.promissoryNotes.createdAt) }}</td>
                        <td>{{ $filters.formatDate(promissoryN.promissoryNotes.updatedAt) }}</td>
                        <td>
                            <PrimaryButton class="btn-success" @click="$emit('edit', promissoryN)" data-toggle="modal"
                                data-target="#promissoryNoteModal">
                                <i class="fa fa-edit"></i>
                            </PrimaryButton>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="9" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import { usePromissoryNoteStore } from '@/pinia/LoanApplications/Legal/usePromissoryNoteStore.module';
import { getCurrentInstance } from 'vue';

const props = defineProps({
    promissoryNotes: {
        type: Array,
        required: true,
        default: () => []
    }
});

/**
 * Abre el modal para editar un registro de carátula
 * Acción por el boton de la tabla
 */
const emit = defineEmits(['sort', 'edit']);

const promissoryNoteStore = usePromissoryNoteStore();

//Acceder a las propiedades globales
const instance = getCurrentInstance();
const $filters = instance?.appContext.config.globalProperties.$filters;

const getName = (item) => {
    if (item.prospects.generalInformation.businessName === null) {
        return `${item.prospects.generalInformation.firstName} ${item.prospects.generalInformation.lastName} ${item.prospects.generalInformation.mothersMaidenName}`;
    } else {
        return `${item.prospects.generalInformation.businessName}`;
    }
}
</script>